import { render, staticRenderFns } from "./ProductCategoryModal.vue?vue&type=template&id=daae418e&"
import script from "./ProductCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports